export const LOAD_HOLIDAYS = 'LOAD_HOLIDAYS';
export const CREATE_HOLIDAY = 'CREATE_HOLIDAY';
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY';
export const DELETE_HOLIDAY = 'DELETE_HOLIDAY';
